import { get } from 'lodash';

import { getAxiosClient } from 'utils/axios';

import { SET_USER } from './auth';

import { handleApiError } from './utils';

export const SET_LIST = SET_USER;
export const SET_CURRENT = '@wallpaper/SET_WALLPAPER';
export const LINK_LIST = '@wallpaper/SET_WALLPAPER';

export const getWallpaper = (userId) => async () => {
    const cli = getAxiosClient('wallpaperGetWallpaper', {
        passthrough: (data) => ({ type: SET_CURRENT, data: data.data })
    });
    try {
        const res = await cli.get(`/v1/wallpapers/${userId}`);
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};

export const linkWallpaper = (wallpaperId, userId) => async () => {
    console.log({ userId, wallpaperId });
    const cli = getAxiosClient('wallpaperLinkWallpaper', {
        passthrough: (data) => ({ type: LINK_LIST, data })
    });
    try {
        const res = await cli.post(`/v1/wallpapers/link`, JSON.stringify({ userId, wallpaperId }));
        const status = get(res, 'status') >= 200 && get(res, 'status') < 300;
        if (status) return { error: false };
        else return { error: true };
    } catch (e) {
        return handleApiError(e);
    }
};
